import { Link } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";
import { SITE } from "@/content/site";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="border-t border-border/70">
      <div className="site-container py-10">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <BrandMark size={168} />
            <p className="mt-3 text-xs text-muted-foreground">{SITE.claim} · Metallbau · Reparaturen · Mobile Schweissarbeiten</p>
          </div>
          <div className="flex flex-col gap-2 text-sm sm:items-end">
            <div className="flex items-center gap-5">
              <a href={SITE.phoneHref} data-testid="footer-phone-link" className="text-muted-foreground transition-colors duration-200 hover:text-foreground">
                {SITE.phoneDisplay}
              </a>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="text-muted-foreground transition-colors duration-200 hover:text-foreground">
                {SITE.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-border/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-muted-foreground">
            © {year} {SITE.name}. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-5 text-xs">
            <Link to="/impressum" data-testid="footer-link-impressum" className="text-muted-foreground transition-colors duration-200 hover:text-foreground">
              Impressum
            </Link>
            <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="text-muted-foreground transition-colors duration-200 hover:text-foreground">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
